import { render, staticRenderFns } from "./DialogCommon.vue?vue&type=template&id=38e41f18&scoped=true&"
import script from "./DialogCommon.vue?vue&type=script&lang=js&"
export * from "./DialogCommon.vue?vue&type=script&lang=js&"
import style0 from "./DialogCommon.vue?vue&type=style&index=0&id=38e41f18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e41f18",
  null
  
)

export default component.exports